import React, { Component } from 'react';

import I18N from '../I18N';

class Countdown extends Component {
	constructor(props) {
		super(props);
		this.state = {remaining_seconds: 0};
		for (const m of ["update"]) this[m] = this[m].bind(this);
	}

	update() {
		var remaining_seconds = Math.floor(this.props.end_time - Date.now()/1000);
		if (remaining_seconds < 0) remaining_seconds = 0;

		this.setState({remaining_seconds});
	}

	componentDidMount() {
		this.update();
		if(this.props.only_minutes) {
			this.interval = setInterval(this.update, 30000);
		} else {
			this.interval = setInterval(this.update, 500);
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render() {
		if (!this.props.end_time) return <div/>;
		let remaining_element;
		if(this.props.only_minutes) {
			return <span>{Math.floor(this.state.remaining_seconds / 60)}</span>;
		}
		if (this.state.remaining_seconds > 0) {
			remaining_element = I18N.duration(this.state.remaining_seconds);
		} else {
			let dots = ".";
			let n = Math.floor(Date.now()/500)%4;
			for (let i = 0; i < n; i++) dots += ".";
			remaining_element = <React.Fragment>{dots}</React.Fragment>;
		}
		return <span>{remaining_element}</span>;
	}
}

export default Countdown;



// WEBPACK FOOTER //
// ./src/c/Countdown.js